<template>
    <div>
        <category-header :show-categories="true" />
        <products />
    </div>
</template>

<script>
    import CategoryHeader from '../components/Category/CategoryHeader'
    import Products from '../components/Category/Products'
    import {mapGetters} from 'vuex'

    export default {
        name: 'CategoryPage',
        metaInfo () {
            return {
                title: this.currentCategory ? this.currentCategory.name : '',
            }
        },
        components: {
            CategoryHeader,
            Products
        },
        computed: {
            ...mapGetters([
                'allProducts',
                'currentCategory'
            ])
        }
    }
</script>
